import { useSyncGrowBranding } from './useSyncGrowBranding';

export function GrowBranding(): null {
  useSyncGrowBranding();

  return null;
}
